<template>
  <tr>
    <td>{{ item.title }}</td>
    <td>{{ item.address }}</td>
    <td>{{ item.phone }}</td>
    <td>{{ item.email }}</td>
    <td>{{ item.responsiblePerson }}</td>
    <td>{{ materialName(item.materialTypeId) }}</td>
    <td class="text-right">
      <v-btn flat icon color="black lighten-2" class="mr-0" @click="handleEditClickButton">
        <v-icon small>fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-btn flat icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>
      <confirm ref="confirm"></confirm>
    </td>
  </tr>
</template>

<script>
import {validateStringLength} from '../../helpers/validation'
import Confirm from '../Ui/Confirm'
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'contractor-item',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Confirm
  },
  filters: {},
  data () {
    return {
      validatableRefs: ['title']
    }
  },
  beforeCreate () {

  },
  computed: {
    ...mapState({
      availableContractorMaterials: "availableContractorMaterials"
    }),
  },
  methods: {
    ...mapActions({
      contractorDelete: 'contractorDelete'
    }),
    materialName(id) {
      if (!id) {
        return ""
      }
      return _.find(this.availableContractorMaterials, c => c.id == id).title
    },
    handleEditClickButton () {
      this.$emit('editContractor', this.item)
    },
    async handleDeleteButtonClick () {
      this.$refs.confirm.open('Delete contractor', `Do you want to delete contractor with title: "${this.item.title}"?`, {width: 600}).then(async (confirm) => {
        if (!confirm) {
          return
        }

        try {
          await this.contractorDelete(this.item)
        } catch (e) {
          console.log(e)
        }
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sales/ContractorItem.vue